import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import Header from '../components/Header'
import Utsff from '../img/tourist_1_sff.jpg'
import Utsffd from '../img/tourist_1_sff_desk.jpg'
import Vibst from '../img/viber_stikeri.jpg'
import IheartSa from '../img/iheartsa.jpg'

const Predstavljamo = () => (
  <Layout>    
    <Header>Predstavljamo</Header>
    <section className="section">
    <div className="container">
      <div className="container-pages" style={{ border: 'none' }}>
        <div className="text-promo-header">
          <h4 className="text-promo-large">Super usluge i pogodnosti glavnog sponzora Festivala</h4>
        </div>
        <div className="promo-row">
        	<div className="promo-col-two">
            <div className="text-promo">
              <p className="text-promo-normal">Želite pričati, dopisivati se i surfati dok ste u posjeti Bosni i Hercegovini? Ultra je pravi izbor za vas! Više informacija <a href="https://www.bhtelecom.ba/tourist-ultra.html">ovdje</a>.</p>
            </div>
            <a className="mobile" href="https://www.bhtelecom.ba/en_tourist-ultra.html" target="_blank"><img className='image-mobile-full' src={Utsff} /></a>
            <a className="desktop" href="https://www.bhtelecom.ba/en_tourist-ultra.html" target="_blank"><img className='image-medium' src={Utsffd} /></a>           
          </div>
          <div className="promo-col-two">
            <div className="text-promo">
              <p className="text-promo-normal">Na Viber sticker marketu možete <a href="https://stickers.viber.com/pages/bh_telecom_bih?redir=1" target="_blank">besplatno preuzeti</a> nove extra zabavne stickere s kojima će svakodnevna komunikacija biti mnogo zanimljivija.</p>
            </div>
            <a href="https://stickers.viber.com/pages/bh_telecom_bih?redir=1" target="_blank"><img className='image-medium' src={Vibst} /></a>            
          </div>
        </div>
        <div className="promo-row">
          <div className="promo-col-one"> 
            <div className="text-promo">
              <div className="text-promo-header">
                <h4 className="text-promo-large">
                Besplatan bežični internet 24h
                </h4>
              </div>
              <p className="text-promo-normal">Na nekoliko lokacija u Sarajevu osigurali smo besplatan bežični pristup internetu za naše korisnike, goste SFF-a i turiste.</p>
              <p className="text-promo-normal">Free WiFi zone nalaze se na tramvajskim stajalištima:
                <ul>
                  <li>Baščaršija</li>
                  <li>Banka</li>
                  <li>Park</li>
                </ul>
              </p>
              <p className="text-promo-normal">
                Uživajte dijeleći svoje fotografije i priče iz filmskog Sarajeva!
              </p>
            </div>    
          </div>
        </div>
        <div className="promo-row">
          <div className="promo-col-one"> 
            <div className="text-promo">
              <div className="text-promo-header">
                <h4 className="text-promo-large">
                Prodajna mjesta
                </h4>
              </div>
              <p className="text-promo-normal">U glavnom gradu BiH na 15 lokacija su prodajna mjesta na kojima možete kupiti sve usluge iz ponude BH Telecoma, kao i uređaje, dopuniti prepaid račun, obaviti plaćanje računa, itd.</p>
              <p className="text-promo-normal">Zatreba li vam Ultra Tourist SE paket ili želite imati Moja TV ili internet za vrijeme vašeg boravka u Sarajevu zapratite stopice po centru grada, dovest će vas do najbližeg prodajnog mjesta, a naše ljubazno osoblje potrudit će da nas napustite zadovoljni.</p>
              <p className="text-promo-normal">Dva prodajna mjesta BH Telecoma, tokom trajanja Sarajevo Film Festivala od 16. do 22. avgusta, imat će „festivalsko“ radno vrijeme:</p>
              <div className="text-promo-header">
                <p className="text-promo-large">BH TELECOM CENTAR SARAČI</p>
              </div>
              <p className="text-promo-normal">
                Sarači 60 
                od 08:00 do 24:00 sati od ponedjeljka do subote, nedjeljom od 10:00 do 18.00 sati
              </p>
              <div className="text-promo-header">
                <p className="text-promo-large">INFO PRODAJNI PULT BBI</p>
              </div>
              <p className="text-promo-normal">
                Trg djece Sarajeva 1
                od 09:00 do 22:00 sati od ponedjeljka do subote, nedjeljom od 10:00 do 18.00 sati.
              </p>
            </div>    
          </div>
        </div>
			</div>
		</div>
		</section>
  </Layout>
)

export default Predstavljamo